import { baseURL } from '..';
import { IProject, IProjectInfo } from '../../shared/iProject';
import httpClient, { IPaginatedResponse, IResponse } from '../httpClient';
import { createHeaders, createRequest, paginationQuery } from '../util';
import { ICreateExistingProject } from './iApiRequest';
import { IGetProjectPreviewResponse } from './iApiResponse';

const ProjectProvider = () => {
    const getProjectPreviewAsync = (email: string, pageNumber?: number, pageSize?: number, name?: string): Promise<IResponse<IPaginatedResponse<IGetProjectPreviewResponse>>> =>
        httpClient.getAsync(createRequest(baseURL, `/Project/GetPaginatedPreviewsByAuthorEmail/${email}`, paginationQuery(pageNumber, pageSize, name)), createHeaders());

    const createProjectAsync = (payload: IProjectInfo): Promise<IResponse<IProject>> => httpClient.postAsync(createRequest(baseURL, `/Project/CreateProject`, undefined, payload), createHeaders());

    const createFromExistingProjectAsync = (payload: ICreateExistingProject): Promise<IResponse<IProject>> =>
        httpClient.postAsync(createRequest(baseURL, `/Project/createFromExistingProject`, undefined, payload), createHeaders());

    const getProjectAsync = (id: number, email: string): Promise<IResponse<IProject>> =>
        httpClient.getAsync(createRequest(baseURL, `/Project/GetProject`, `?id=${id}&authorEmail=${email}`), createHeaders());

    const deleteProjectAsync = (id: number): Promise<IResponse> => httpClient.deleteAsync(createRequest(baseURL, `/Project/DeleteProject`, `?id=${id}`), createHeaders());

    const updateProjectAsync = (payload: IProject): Promise<IResponse<IProject>> => httpClient.putAsync(createRequest(baseURL, `/Project/UpdateProject`, undefined, payload), createHeaders());

    return { getProjectPreviewAsync, createProjectAsync, getProjectAsync, deleteProjectAsync, updateProjectAsync, createFromExistingProjectAsync };
};

export default ProjectProvider();
